import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { NotificationTypeInfo } from 'types/notification_rule';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseNotificationTypesOptions = UseQueryOptions<
  NotificationTypeInfo[],
  APIError
>;

export function useNotificationTypes(
  options: UseNotificationTypesOptions = {}
) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    ['notification-types', applicationID],
    async () => {
      const { data } = await client.get<NotificationTypeInfo[]>(
        `/apps/${applicationID}/notification_types`
      );
      return data;
    },
    { staleTime: Infinity, ...options }
  );
}
